import { useCallback, useEffect, useState } from "react";
import useLocalStorage from "app/model/LocalStorage";

export default function useReminder(reminderName, daysToAddOnSnooze) {
    const [dontActivateBefore, setDontActivateBefore] =
        useLocalStorage(reminderName+'_dontActivateBefore', undefined);

    const [itIsTime, setIsTime] =
        useState(
            (dontActivateBefore === undefined) ||
            (Date.now() > dontActivateBefore));

    useEffect(() => {
        let passedTheTime =
            (dontActivateBefore === undefined) ||
            (Date.now() > dontActivateBefore);
        setIsTime(passedTheTime);

        if (!passedTheTime) {
            let i = setInterval(() => {
                setIsTime(
                    (dontActivateBefore === undefined) ||
                    (Date.now() > dontActivateBefore));
            }, 1000 * 60 * 60) // 1h
            // }, 1000 * 10) // 10s
            return () => { clearInterval(i) };
        }
    }, [dontActivateBefore, itIsTime]);

    const snooze = useCallback(() => {
        let today = new Date();
        let otherDay = new Date();
        otherDay.setDate(today.getDate() + daysToAddOnSnooze); // 1d
        otherDay.setHours(3); // at 3am
        let _dontActivateBefore = otherDay.getTime();
        // let _dontActivateBefore = today.getTime() + 1000 * 10;  // 10s
        setDontActivateBefore(_dontActivateBefore);
    }, [setDontActivateBefore, daysToAddOnSnooze]);

    return [itIsTime, snooze]
}